module.exports = __webpack_public_path__ + "img/stena07.08087981.jpg";